import { Observable } from '../Observable.js'; // TODO: Moved observable in another PR
import { uuidv4 } from '../uuidv4.js';
/**
 * The interaction is responsible for notifying listeners of when the scene enters and leaves a state of expected continues change.
 * For example when the user is moving the currently active camera or is dragging an object in the scene.
 * This is useful for turning of things like temporal effects and limit updating of things like reflection probes.
 * The interaction system can be disabled with the viewer creation config, this will stop cause begin_interaction and end_interaction to NOP
 */
export class InteractionSystem {
    get interaction_begin_observable() {
        return this._interaction_begin_observable;
    }
    get interaction_end_observable() {
        return this._interaction_end_observable;
    }
    get is_interacting() {
        return this._active_interactions.size > 0;
    }
    constructor(_viewer, enabled) {
        this._viewer = _viewer;
        this._active_interactions = new Set();
        this._interaction_begin_observable = new Observable();
        this._interaction_end_observable = new Observable();
        this._enabled = enabled;
    }
    begin_interaction() {
        if (!this._enabled)
            return '';
        const interaction_id = uuidv4();
        this._active_interactions.add(interaction_id);
        // This is the first active interaction so we need to signal begin.
        if (this._active_interactions.size === 1) {
            this.interaction_begin_observable.notify(this);
        }
        return interaction_id;
    }
    end_interaction(interaction_id) {
        if (!this._enabled)
            return false;
        const was_deleted = this._active_interactions.delete(interaction_id);
        // Something was deleted, and we no longer have any active interactions, signal end.
        if (was_deleted && this._active_interactions.size === 0) {
            this.interaction_end_observable.notify(this);
        }
        return was_deleted;
    }
}
//# sourceMappingURL=InteractionSystem.js.map